<div class="main_box">
    <div class="">
        <div class="modal-header" style="background-color: #294058;">
             <h4 class="modal-title" style="margin: auto;color: white;">Device Info: &nbsp;{{mdcData?.siteName || 'N/A'}}</h4>
        </div>
        <div class="">
            <div class="grid-container">
                <div class="grid-item"><p class="device_info_heading">SITE NAME</p><p class="device_info">{{mdcData?.siteName || 'N/A'}}</p></div>
                <div class="grid-item"><p class="device_info_heading">SITE TYPE</p><p class="device_info">{{mdcData?.siteType || 'N/A'}}</p></div>
                <div class="grid-item"><p class="device_info_heading">POTENTIAL ID</p><p class="device_info">{{mdcData?.potentialId || 'N/A'}} </p></div>  
                <div class="grid-item"><p class="device_info_heading">DEVICE NAME</p><p class="device_info">{{mdcData?.deviceName || 'N/A'}} </p></div>
                <div class="grid-item"><p class="device_info_heading">STATUS</p><p class="device_info">{{((mdcData?.status)?(mdcData?.status):'N/A')}} </p></div>
            </div> <br>
              <div class="grid-container1">
                <div class="grid-item1">
                    <p class="device_info bold_font" >HOLIDAYS/EXCEPTIONAL DAYS </p>
                    <div class="device_info row col-md-1 col-sm-2" style="display:inline-flex">
                        <div class="bold_font">Date :</div>
                        <div class="bold_font">Uptime Start:</div>
                        <div class="bold_font">Uptime End:</div>
                    </div>
                    <div class="device_info row col-md-1 col-sm-2" style="display:inline-flex" *ngIf="mdcData?.mdxScriptBO?.solarInfo == null">
                        <span><strong>N/A</strong></span>
                        <div>
                             <p>
                                <span style="display:inline-flex"> N//A</span>
                                <br>
                                <span style="display:inline-flex">N/A</span>
                            </p>
                        </div>
                    </div>
                    <div class="device_info row col-md-1 col-sm-2" style="display:inline-flex" *ngFor="let datetime of mdcData?.mdxScriptBO?.solarInfo?.exceptionDays">
                        <span><strong>{{(datetime.date)?(datetime.date):'N/A'}}</strong></span>
                        <div>
                             <p *ngFor="let uptime of datetime?.times">
                                <span style="display:inline-flex"> {{(uptime.monitoringStart)?(uptime.monitoringStart):'N/A'}}</span>
                                <br>
                                <span style="display:inline-flex">{{uptime.monitoringEnd?(uptime.monitoringEnd):'N/A'}}</span>
                            </p>
                        </div>
                    </div>
                </div>
              </div>
              <div class="grid-container1">
                <div class="grid-item1">
                    <p class="device_info bold_font" style="background-color: #294058; color: white;" >SOLAR SCRIPT TIMES</p>
                     <div class="grid-container" style="padding-bottom: 10px;">
                        <div class="grid-item1">
                            <p class="device_info_heading" style="border: 1px solid black; color: green;">MONDAY</p>
                            <p class="device_info_heading"><u>Morning:</u></p>
                            <div class="row">
                                <p class="device_info_heading">Monitoring Start :  {{mdcData?.mdxScriptBO?.solarInfo?.weekdays[0]?.monday?.times[0]?.monitoringStart || 'N/A'}}</p>
                              </div>
                              <div class="row">
                                <p class="device_info_heading">Monitoring End : {{mdcData?.mdxScriptBO?.solarInfo?.weekdays[0]?.monday?.times[0]?.monitoringEnd || 'N/A'}}</p>
                              </div>
                              <hr>
                              <p class="device_info_heading"><u>Evening:</u></p>
                              <div class="row">
                                <p class="device_info_heading">Monitoring Start : {{mdcData?.mdxScriptBO?.solarInfo?.weekdays[0]?.monday?.times[1]?.monitoringStart || 'N/A'}}</p>
                              </div>
                              <div class="row">
                                <p class="device_info_heading">Monitoring End : {{mdcData?.mdxScriptBO?.solarInfo?.weekdays[0]?.monday?.times[1]?.monitoringEnd || 'N/A'}}</p>
                              </div>
                        </div>

                        <div class="grid-item1"><p class="device_info_heading" style="border: 1px solid black; color: green;">TUESDAY</p>
                            <p class="device_info_heading"><u>Morning:</u></p>
                            <div class="row">
                                <p class="device_info_heading">Monitoring Start :  {{mdcData?.mdxScriptBO?.solarInfo?.weekdays[1]?.tuesday?.times[0]?.monitoringStart || 'N/A'}}</p>
                              </div>
                              <div class="row">
                                <p class="device_info_heading">Monitoring End : {{mdcData?.mdxScriptBO?.solarInfo?.weekdays[1]?.tuesday?.times[0]?.monitoringEnd || 'N/A'}}</p>
                              </div>
                              <hr>
                              <p class="device_info_heading"><u>Evening:</u></p>
                              <div class="row">
                                <p class="device_info_heading">Monitoring Start : {{mdcData?.mdxScriptBO?.solarInfo?.weekdays[1]?.tuesday?.times[1]?.monitoringStart || 'N/A'}}</p>
                              </div>
                              <div class="row">
                                <p class="device_info_heading">Monitoring End : {{mdcData?.mdxScriptBO?.solarInfo?.weekdays[1]?.tuesday?.times[1]?.monitoringEnd || 'N/A'}}</p>
                              </div>
                        </div>
                        <div class="grid-item1"><p class="device_info_heading" style="border: 1px solid black; color: green;">WEDNESDAY</p>
                            <p class="device_info_heading"><u>Morning:</u></p>
                            <div class="row">
                                <p class="device_info_heading">Monitoring Start :  {{mdcData?.mdxScriptBO?.solarInfo?.weekdays[2]?.wednesday?.times[0]?.monitoringStart || 'N/A'}}</p>
                              </div>
                              <div class="row">
                                <p class="device_info_heading">Monitoring End : {{mdcData?.mdxScriptBO?.solarInfo?.weekdays[2]?.wednesday?.times[0]?.monitoringEnd || 'N/A'}}</p>
                              </div>
                              <hr>
                              <p class="device_info_heading"><u>Evening:</u></p>
                              <div class="row">
                                <p class="device_info_heading">Monitoring Start : {{mdcData?.mdxScriptBO?.solarInfo?.weekdays[2]?.wednesday?.times[1]?.monitoringStart || 'N/A'}}</p>
                              </div>
                              <div class="row">
                                <p class="device_info_heading">Monitoring End : {{mdcData?.mdxScriptBO?.solarInfo?.weekdays[2]?.wednesday?.times[1]?.monitoringEnd || 'N/A'}}</p>
                              </div>
                        </div>  
                        <div class="grid-item1"><p class="device_info_heading" style="border: 1px solid black;color: green">THURSDAY</p>
                            <p class="device_info_heading"><u>Morning:</u></p>
                            <div class="row">
                                <p class="device_info_heading">Monitoring Start :  {{mdcData?.mdxScriptBO?.solarInfo?.weekdays[3]?.thursday?.times[0]?.monitoringStart || 'N/A'}}</p>
                              </div>
                              <div class="row">
                                <p class="device_info_heading">Monitoring End : {{mdcData?.mdxScriptBO?.solarInfo?.weekdays[3]?.thursday?.times[0]?.monitoringEnd || 'N/A'}}</p>
                              </div>
                              <hr>
                              <p class="device_info_heading"><u>Evening:</u></p>
                              <div class="row">
                                <p class="device_info_heading">Monitoring Start : {{mdcData?.mdxScriptBO?.solarInfo?.weekdays[3]?.thursday?.times[1]?.monitoringStart || 'N/A'}}</p>
                              </div>
                              <div class="row">
                                <p class="device_info_heading">Monitoring End : {{mdcData?.mdxScriptBO?.solarInfo?.weekdays[3]?.thursday?.times[1]?.monitoringEnd || 'N/A'}}</p>
                              </div>
                        </div>
                        <div class="grid-item1"><p class="device_info_heading" style="border: 1px solid black;color: green">FRIDAY</p>
                            <p class="device_info_heading"><u>Morning:</u></p>
                            <div class="row">
                                <p class="device_info_heading">Monitoring Start :  {{mdcData?.mdxScriptBO?.solarInfo?.weekdays[4]?.friday?.times[0]?.monitoringStart || 'N/A'}}</p>
                              </div>
                              <div class="row">
                                <p class="device_info_heading">Monitoring End : {{mdcData?.mdxScriptBO?.solarInfo?.weekdays[4]?.friday?.times[0]?.monitoringEnd || 'N/A'}}</p>
                              </div><hr>
                              <p class="device_info_heading"><u>Evening:</u></p>
                              <div class="row">
                                <p class="device_info_heading">Monitoring Start : {{mdcData?.mdxScriptBO?.solarInfo?.weekdays[4]?.friday?.times[1]?.monitoringStart || 'N/A'}}</p>
                              </div>
                              <div class="row">
                                <p class="device_info_heading">Monitoring End : {{mdcData?.mdxScriptBO?.solarInfo?.weekdays[4]?.friday?.times[1]?.monitoringEnd || 'N/A'}}</p>
                              </div>
                        </div>
                          <div class="grid-item1"><p class="device_info_heading" style="border: 1px solid black;color:green">SATURDAY</p>
                            <p class="device_info_heading"><u>Morning:</u></p>  
                            <div class="row">
                              <p class="device_info_heading">Monitoring Start :  {{mdcData?.mdxScriptBO?.solarInfo?.weekdays[5]?.saturday?.times[0]?.monitoringStart || 'N/A'}}</p>
                            </div>
                            <div class="row">
                              <p class="device_info_heading">Monitoring End : {{mdcData?.mdxScriptBO?.solarInfo?.weekdays[5]?.saturday?.times[0]?.monitoringEnd || 'N/A'}}</p>
                            </div><hr>
                            <p class="device_info_heading"><u>Evening:</u></p>  
                            <div class="row">
                              <p class="device_info_heading">Monitoring Start :  {{mdcData?.mdxScriptBO?.solarInfo?.weekdays[5]?.saturday?.times[1]?.monitoringStart || 'N/A'}}</p>
                            </div>
                            <div class="row">
                              <p class="device_info_heading">Monitoring End : {{mdcData?.mdxScriptBO?.solarInfo?.weekdays[5]?.saturday?.times[1]?.monitoringEnd || 'N/A'}}</p>
                            </div>
                      </div>
                      <div class="grid-item1"><p class="device_info_heading" style="border: 1px solid black;color: green">SUNDAY</p>
                        <p class="device_info_heading"><u>Morning:</u></p>    
                        <div class="row">
                              <p class="device_info_heading">Monitoring Start :  {{mdcData?.mdxScriptBO?.solarInfo?.weekdays[6]?.sunday?.times[0]?.monitoringStart || 'N/A'}}</p>
                            </div>
                            <div class="row">
                              <p class="device_info_heading">Monitoring End : {{mdcData?.mdxScriptBO?.solarInfo?.weekdays[6]?.sunday?.times[0]?.monitoringEnd || 'N/A'}}</p>
                            </div><hr>
                            <p class="device_info_heading"><u>Evening:</u></p>
                            <div class="row">
                              <p class="device_info_heading">Monitoring Start :  {{mdcData?.mdxScriptBO?.solarInfo?.weekdays[6]?.sunday?.times[1]?.monitoringStart || 'N/A'}}</p>
                            </div>
                            <div class="row">
                              <p class="device_info_heading">Monitoring End : {{mdcData?.mdxScriptBO?.solarInfo?.weekdays[6]?.sunday?.times[1]?.monitoringEnd || 'N/A'}}</p>
                            </div>
                      </div>
                    </div>        
                </div>
        </div>
    </div>
</div>

